// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-7ed11566]{width:100%;border-style:dashed;border-width:1px;display:flex}", ""]);
// Exports
module.exports = exports;
